import useDynamicsStatusCall from "./manage-status/useDynamicsStatusCall";
import useHubspotStatusCall from "./manage-status/useHubspotStatusCall";
import useSalesforceStatusCall from "./manage-status/useSalesforceStatusCall";

export const useAllCrmStatusesCall = (): void => {
    useSalesforceStatusCall();
    useHubspotStatusCall();
    useDynamicsStatusCall();
};
